import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { getSurveyList } from "./Services/surveyService";
import { Chart } from "primereact/chart";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import moment from "moment";
const SurvayResponse = () => {
  const { SurveyFormId } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [formInfo, setFormInfo] = useState([]);
  const [surveyList, setSurveyList] = useState([]);
  const [IsLoading, setLoading] = useState();
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    GetSurveyList();
  }, [SurveyFormId]);

  async function GetSurveyList() {
    setLoading(true);
    const params = {
      FormId: 0,
      EmpGUID: "",
      FormGUID: SurveyFormId,
      PageNumber: 1,
      PageSize: 10000,
      EmpId: userDetails.OrgId,
      MyCreatedSurvey: 0,
      MyParticipation: 0,
      Search:"",
    };
    try {
      const response = await getSurveyList(params);
      setFormInfo(response?.Data[0]);
      setSurveyList(response?.Data);
      const prefill = {};

      response?.Data?.forEach((item) => {
        item?.Questions?.forEach((q) => {
          const type = Number(q.QuestionType);

          if (type === 101) {
            // Checkbox
            const selected = q.Options.filter(o => o.EmpSelectedOptionId > 0);

            prefill[q.QuestionId] = {
              OptionId: selected.map(o => o.OptionId), // ✅ FIXED
              TextAnswer: selected.map(o => o.EmpResponseText),
            };
          }

          else if (type === 102 || type === 103) {
            // Radio / Dropdown
            const selected = q.Options.find(o => o.EmpSelectedOptionId > 0);

            prefill[q.QuestionId] = {
              OptionId: selected?.OptionId || null, // ✅ FIXED
              TextAnswer: selected?.EmpResponseText || "",
            };
          }

          else if (type === 104) {
            // Text
            prefill[q.QuestionId] = {
              OptionId: 0,
              TextAnswer: q.Options?.[0]?.EmpResponseText || "",
            };
          }
        });
      });
      setAnswers(prefill);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //  toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoading(false);
      //  setLoading(false);
    }
  }

  const optionKeyByType = {
    101: "Checkbox",
    102: "Radio",
    103: "Dropdown",
    104: "Text",
  };

  // const renderOptionsByType = (el) => {
  //   const type = Number(el.QuestionType);

  //   switch (type) {
  //     case 101: // Checkbox
  //       return el?.Options?.map((opt, i) => (
  //         <div className="form-check" key={i}>
  //           <input className="form-check-input" type="checkbox" disabled />
  //           <label className="form-check-label">{opt.OptionText}</label>
  //         </div>
  //       ));

  //     case 102: // Radio
  //       return el?.Options?.map((opt, i) => (
  //         <div className="form-check" key={i}>
  //           <input
  //             className="form-check-input"
  //             type="radio"
  //             name={`q-${el.QuestionId}`}
  //             disabled
  //           />
  //           <label className="form-check-label">{opt.OptionText}</label>
  //         </div>
  //       ));

  //     case 103: // Dropdown
  //       return (
  //         <select className="form-select">
  //           {el?.Options?.map((opt, i) => (
  //             <option key={i}>{opt.OptionText}</option>
  //           ))}
  //         </select>
  //       );

  //     case 104: // Text Input
  //       return (
  //         <input
  //           type="text"
  //           className="form-control"
  //           placeholder="User response"
  //           disabled
  //         />
  //       );

  //     default:
  //       return null;
  //   }
  // };

  const renderOptionsByType = (el) => {
    const type = Number(el.QuestionType);

    switch (type) {


      case 101:
        return el.Options.map((opt) => (
          <div className="form-check" key={opt.OptionId}>
            <input
              className="form-check-input"
              type="checkbox"
              disabled
              checked={
                Array.isArray(answers?.[el.QuestionId]?.OptionId) &&
                answers[el.QuestionId].OptionId.includes(opt.OptionId)
              }
            />
            <label className="form-check-label">
              {opt.OptionText}
            </label>
          </div>
        ));
      case 102:
        return el?.Options?.map((opt) => (
          <div className="form-check" key={opt.OptionId}>
            <input
              className="form-check-input"
              disabled
              type="radio"
              name={`q-${el.QuestionId}`}
              checked={answers?.[el.QuestionId]?.OptionId === opt.OptionId}

            />
            <label className="form-check-label">{opt.OptionText}</label>
          </div>
        ));

      case 103:
        return (
          <select
            className="form-select"
            disabled
            multiple
            value={
              answers?.[el.QuestionId]?.OptionId
                ? [answers[el.QuestionId].OptionId]
                : []
            }
            onChange={(e) => {
              const selectedOptions = Array.from(e.target.selectedOptions);

              const optionId = selectedOptions[0]
                ? Number(selectedOptions[0].value)
                : null;

              const text = selectedOptions[0]
                ? selectedOptions[0].text
                : "";


            }}
          >
            {el?.Options?.map((opt) => (
              <option key={opt.OptionId} value={opt.OptionId}>
                {opt.OptionText}
              </option>
            ))}
          </select>
        );
      case 104:
        return (
          <input
            type="text"
            disabled
            className="form-control"
            value={answers?.[el.QuestionId]?.TextAnswer || ""}

          />
        );
      default:
        return null;
    }
  };
  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">{formInfo?.Title}</h2>
                <p className="font-w600 mb-0">{formInfo?.Description}</p>
              </div>
              <div className="rightside-tabs">
                <div className="top-pints-bx">
                  <div className="fs-15 text-danger">
                    {moment(formInfo?.InitiatedOn).format("DD MMM YYYY")}
                  </div>
                  {/* <label className="form-label">Time to complete</label> */}
                </div>
                <Link to="/Survey/List">
                  <button
                    className="add-newticket w-auto float-right"
                    style={{ minWidth: "fit-content" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>


          <div className="col-xl-12">
            {surveyList?.map((item) => (
              <>
                {item?.Questions?.map((el, index) => (
                  <div className="assessment-block p-3" key={index}>
                    <div className="illustration-header00 mb-3">
                      <div className="header-meta">
                        <div className="mb-3">
                          <h3>
                            {index + 1}. {el?.QuestionTitle}{" "}
                          </h3>
                        </div>
                        <div className="question-options">
                          <div className="row align-items-center">
                            <div className="col-lg-8">
                              {renderOptionsByType(el)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
      </div>

      {IsLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default SurvayResponse;
